const FILENAME_FALLBACK = 'dreamable-story';

/**
 * German-aware filename sanitization for the `<a download>` attribute.
 * Folds umlauts (ä→ae, ö→oe, ü→ue, ß→ss) before stripping non-word
 * chars so "Käpt'n Kuschel" becomes "Kaeptn-Kuschel.pdf" instead of
 * "Kpt-Kuschel.pdf". Falls back to "dreamable-story" if the title is
 * missing or sanitizes to empty.
 *
 * Returns the bare stem (no extension) — callers append ".pdf" to keep
 * the helper extension-agnostic for any future audio/text exports.
 */
export function sanitizeFilename(title: string | undefined | null): string {
  if (!title) return FILENAME_FALLBACK;
  const folded = title
    .replace(/ä/g, 'ae')
    .replace(/Ä/g, 'Ae')
    .replace(/ö/g, 'oe')
    .replace(/Ö/g, 'Oe')
    .replace(/ü/g, 'ue')
    .replace(/Ü/g, 'Ue')
    .replace(/ß/g, 'ss')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return folded || FILENAME_FALLBACK;
}
